<template>
    <b-modal :id="id" dialog-class="modal-lg" @shown="shown" no-close-on-backdrop>
        <template slot="modal-header">
            <span>{{$t('views.g4s.communityactivityapplication.communityactivityapplication_name')}}</span>
            <b-button class="close" @click="cancel">
                <b-icon-x></b-icon-x>
            </b-button>
        </template>
        <div class="alert alert-warning" role="alert">
            1. {{$t('views.g4s.communityactivityapplication.bulletin_board1')}}<br>
            2. {{$t('views.g4s.communityactivityapplication.bulletin_board3')}}
        </div>
        <div role="tablist">
            <b-button class="mb-1" block v-b-toggle.accordion-1>{{$t('views.g4s.communityactivityapplication.basic_info')}}</b-button>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                <div class="card mb-1">
                    <div class="card-body row">
                        <div class="col-md-4 col-sm-12">
                            <form-input v-model="vm.SYear" id="SYear" :label="$t('views.g4s.communityactivityapplication.syear')" type="number" required></form-input>
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <form-select v-model="vm.Semester" id="Semester" :label="$t('views.g4s.communityactivityapplication.semester')" required>
                                <div is="option" value="u">{{$t('views.g4s.communityactivityapplication.semester_first')}}</div>
                                <div is="option" value="d">{{$t('views.g4s.communityactivityapplication.semester_second')}}</div>
                            </form-select>
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <form-input v-model="vm.No" id="No" :label="$t('views.g4s.communityactivityapplication.no')" type="text" disabled></form-input>
                        </div>
                        <div class="col-12">
                            <form-input v-model="vm.Name" id="Name" :label="$t('views.g4s.communityactivityapplication.name')" type="text" required></form-input>
                        </div>
                        <div class="col-12">
                            <form-textarea v-model="vm.Purpose" id="Purpose" :label="$t('views.g4s.communityactivityapplication.purpose')" required></form-textarea>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        {{$t('views.g4s.communityactivityapplication.time_card')}}
                    </div>
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-date-input v-model="vm.StartDay" id="StartDay" :label="$t('views.g4s.communityactivityapplication.startDay')" required></form-date-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.StartTime" id="StartTime" :label="$t('views.g4s.communityactivityapplication.startTime')" type="time" required></form-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-date-input v-model="vm.EndDay" id="EndDay" :label="$t('views.g4s.communityactivityapplication.endDay')" required></form-date-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.EndTime" id="EndTime" :label="$t('views.g4s.communityactivityapplication.endTime')" type="time" required></form-input>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        {{$t('views.g4s.communityactivityapplication.place_card')}}
                    </div>
                    <div class="card-body row">
                        <div class="col-md-1 col-sm-12">
                            <div class="form-group">
                                <label>{{$t('views.g4s.communityactivityapplication.onCampus')}}</label>
                                <label class="form-control">
                                    <input type="checkbox" v-model="vm.OnCampus" true-value="true" />
                                </label>
                            </div>
                        </div>
                        <div class="col-md-11 col-sm-12">
                            <form-input v-model="vm.Place" id="Place" :label="$t('views.g4s.communityactivityapplication.place')" type="text" required></form-input>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        {{$t('views.g4s.communityactivityapplication.participants_card')}}
                    </div>
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.Internals" id="Internals" :label="$t('views.g4s.communityactivityapplication.internals')" type="number"></form-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.Outsiders" id="Outsiders" :label="$t('views.g4s.communityactivityapplication.outsiders')" type="number"></form-input>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        {{$t('views.g4s.communityactivityapplication.community_card')}}
                    </div>
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-select v-model="property" id="property" :label="$t('views.g4s.communityactivityapplication.property')">
                                <div is="option" value="">{{$t('views.g4s.communityactivityapplication.property_all')}}</div>
                                <div is="option" v-for="o in propertys" :key="o.key" :value="o.key">{{o.value}}</div>
                            </form-select>
                        </div>
                        <div class="col-md-6 col-sm-12"></div>
                        <div class="col-md-6 col-sm-12">
                            <form-select v-model="vm.CommunityID" id="CommunityID" :label="$t('views.g4s.communityactivityapplication.community')" required>
                                <div is="option" value="">{{$t('views.g4s.communityactivityapplication.community_choose')}}</div>
                                <div is="option" v-for="item in Communitys" :key="item.key" :value="item.key">{{item.value}}</div>
                            </form-select>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <label><span class="text-danger">* </span>{{$t('views.g4s.communityactivityapplication.studentNo')}}</label>
                            <input v-model="vm.StudentNo" id="StudentNo" type="text" class="form-control" @change="studentNoChange" />
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.StudentName" id="StudentName" :label="$t('views.g4s.communityactivityapplication.studentName')" type="text" disabled required></form-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-select v-model="vm.ClassID" :label="$t('views.g4s.communityactivityapplication.classId')" required>
                                <div is="option" v-for="o in classList" :key="o.key" :value="o.key">{{o.value}}</div>
                            </form-select>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.Phone" id="Phone" :label="$t('views.g4s.communityactivityapplication.phone')" type="tel" required></form-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.Email" id="Email" :label="$t('views.g4s.communityactivityapplication.email')" type="email" required></form-input>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        <span class="text-danger">*</span> {{$t('views.g4s.communityactivityapplication.communitycheck_card')}}
                    </div>
                    <div class="card-body row">
                        <div class="col-12">
                            <label>
                                <input v-model="vm.SelfCheck1" type="checkbox" true-value="true" />{{$t('views.g4s.communityactivityapplication.selfCheck1')}}
                            </label><br />
                            <label>
                                <input v-model="vm.SelfCheck2" type="checkbox" true-value="true" />{{$t('views.g4s.communityactivityapplication.selfCheck2')}}
                            </label><br />
                            <label>
                                <input v-model="vm.SelfCheck3" type="checkbox" true-value="true" />{{$t('views.g4s.communityactivityapplication.selfCheck3')}}
                            </label><br />
                            <label>
                                <input v-model="vm.SelfCheck4" type="checkbox" true-value="true" @change="selfCheckChange('4')" />{{$t('views.g4s.communityactivityapplication.selfCheck4')}}
                            </label><br />
                            <label>
                                <input v-model="vm.SelfCheck5" type="checkbox" true-value="true" @change="selfCheckChange('5')" />{{$t('views.g4s.communityactivityapplication.selfCheck5')}}
                            </label><br />
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        <span class="text-danger">* </span>
                        {{$t('views.g4s.communityactivityapplication.budgetSource_card')}}
                    </div>
                    <div class="card-body row">
                        <div class="col-md-3 col-sm-12">
                            <form-input v-model="vm.BudgetSource1" id="BudgetSource1" :label="$t('views.g4s.communityactivityapplication.budgetSource1')" type="number" placeholder="請輸入金額(元)"></form-input>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <form-input v-model="vm.BudgetSource2" id="BudgetSource2" :label="$t('views.g4s.communityactivityapplication.budgetSource2')" type="number" placeholder="請輸入金額(元)"></form-input>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <form-input v-model="vm.BudgetSource3" id="BudgetSource3" :label="$t('views.g4s.communityactivityapplication.budgetSource3')" type="number" placeholder="請輸入金額(元)"></form-input>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <form-input v-model="vm.BudgetSource4" id="BudgetSource4" :label="$t('views.g4s.communityactivityapplication.budgetSource4')" type="number" placeholder="請輸入金額(元)"></form-input>
                        </div>
                    </div>
                </div>

            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-2 @click="show2">{{$t('views.g4s.communityactivityapplication.unionCommunity_card')}}</b-button>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel" v-if="isedit">
                <table class="table">
                    <thead>
                        <tr>
                            <th>{{$t('views.g4s.communityactivityapplication.unionCommunitySeq')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.property')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.community')}}</th>
                            <th v-if="!isSendOrPass"></th>
                        </tr>
                    </thead>
                    <tr v-for="(item, index) in unionTableData.value" :key="item.CommunityActivityUnionID">
                        <td>{{index + 1}}</td>
                        <td>{{item.PropertyName}}</td>
                        <th>{{item.CommunityName}}</th>
                        <th v-if="!isSendOrPass">
                            <b-button variant="danger" @click="unionDel(item.CommunityActivityUnionID)">{{$t('views.g4s.communityactivityapplication.delete')}}</b-button>
                        </th>
                    </tr>
                    <tr v-if="!isSendOrPass">
                        <td data-th="項次"></td>
                        <td data-th="性質">
                            <form-select v-model="union.property">
                                <div is="option" value="">{{$t('views.g4s.communityactivityapplication.property_all')}}</div>
                                <div is="option" v-for="o in propertys" :key="o.key" :value="o.key">{{o.value}}</div>
                            </form-select>
                        </td>
                        <td data-th="社團">
                            <form-select v-model="union.CommunityID">
                                <div is="option" value="">{{$t('views.g4s.communityactivityapplication.community_choose')}}</div>
                                <div is="option" v-for="item in unionCommunitys" :key="item.key" :value="item.key">{{item.value}}</div>
                            </form-select>
                        </td>
                        <td style="vertical-align:bottom">
                            <div class="form-group">
                                <b-button variant="primary" @click="unionSave">{{$t('views.g4s.communityactivityapplication.insert')}}</b-button>
                            </div>
                        </td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="unionTableData.count" :rowperpage="10" @paging="load"></pagination>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-3 @click="show">{{$t('views.g4s.communityactivityapplication.activityProposal_card')}}</b-button>
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel" v-if="isedit">
                <div class="card mb-1">
                    <div class="card-body row">
                        <div class="col-12">
                            <form-input v-model="vm.Name" id="Name" :label="$t('views.g4s.communityactivityapplication.name')" type="text" disabled></form-input>
                        </div>
                        <div class="col-12">
                            <form-textarea v-model="vm.Purpose" :label="$t('views.g4s.communityactivityapplication.purpose')"></form-textarea>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        {{$t('views.g4s.communityactivityapplication.time_card')}}
                    </div>
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-date-input v-model="vm.StartDay" id="StartDay" :label="$t('views.g4s.communityactivityapplication.startDay')" disabled></form-date-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <label>{{$t('views.g4s.communityactivityapplication.startTime')}}</label>
                            <input type="time" v-model="vm.StartTime" class="form-control" disabled />
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-date-input v-model="vm.EndDay" id="EndDay" :label="$t('views.g4s.communityactivityapplication.endDay')" disabled></form-date-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <label>{{$t('views.g4s.communityactivityapplication.endTime')}}</label>
                            <input type="time" v-model="vm.EndTime" class="form-control" disabled />
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        {{$t('views.g4s.communityactivityapplication.place_card')}}
                    </div>
                    <div class="card-body row">
                        <div class="col-md-1 col-sm-12">
                            <div class="form-group">
                                <label>{{$t('views.g4s.communityactivityapplication.onCampus')}}</label>
                                <label class="form-control">
                                    <input type="checkbox" v-model="vm.OnCampus" true-value="true" disabled />
                                </label>
                            </div>
                        </div>
                        <div class="col-md-11 col-sm-12">
                            <form-input v-model="vm.Place" id="Place" :label="$t('views.g4s.communityactivityapplication.place')" type="text" disabled></form-input>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        {{$t('views.g4s.communityactivityapplication.participants_card')}}
                    </div>
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.Internals" id="Internals" :label="$t('views.g4s.communityactivityapplication.internals')" type="number" disabled></form-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.Outsiders" id="Outsiders" :label="$t('views.g4s.communityactivityapplication.outsiders')" type="number" disabled></form-input>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        <span class="text-danger">*</span> {{$t('views.g4s.communityactivityapplication.expectedOutcomes_card')}}
                    </div>
                    <div class="card-body row">
                        <div class="col-md-3 col-sm-12">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.SExpected1" true-value="true" /> {{$t('views.g4s.communityactivityapplication.sExpected1')}}
                            </label>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.SExpected2" true-value="true" /> {{$t('views.g4s.communityactivityapplication.sExpected2')}}
                            </label>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.SExpected3" true-value="true" /> {{$t('views.g4s.communityactivityapplication.sExpected3')}}
                            </label>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.SExpected4" true-value="true" /> {{$t('views.g4s.communityactivityapplication.sExpected4')}}
                            </label>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.SExpected5" true-value="true" /> {{$t('views.g4s.communityactivityapplication.sExpected5')}}
                            </label>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.SExpected6" true-value="true" /> {{$t('views.g4s.communityactivityapplication.sExpected6')}}
                            </label>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.SExpected7" true-value="true" /> {{$t('views.g4s.communityactivityapplication.sExpected7')}}
                            </label>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.SExpected8" true-value="true" /> {{$t('views.g4s.communityactivityapplication.sExpected8')}}
                            </label>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        <span class="text-danger">*</span> {{$t('views.g4s.communityactivityapplication.activityProcess_card')}}
                    </div>
                    <div class="card-body row">
                        <div class="col-12">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.BigScale" true-value="true" /> {{$t('views.g4s.communityactivityapplication.bigScale')}} <br />
                            </label>
                        </div>
                        <div class="col-12">
                            <file-upload :url="'/api/communityactivityapplication/File?id='+vm.CommunityActivityApplicationID+'&no='+vm.No" @ok="ok" v-if="!isSendOrPass"></file-upload>
                            <div v-for="f in vm.Files" :key="f">
                                <a :href="Path+f" target="_blank" v-if="f.includes('活動申請書附件')">{{f}}</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-body row">
                        <div class="col-12">
                            <form-textarea v-model="vm.ActivityDesc" id="ActivityDesc" :label="$t('views.g4s.communityactivityapplication.activityDesc')"></form-textarea>
                        </div>
                        <div class="col-12">
                            <form-textarea v-model.trim="vm.ActivityPeople" id="ActivityPeople" :label="$t('views.g4s.communityactivityapplication.activityPeople')"></form-textarea>
                        </div>
                        <div class="col-12">
                            <form-textarea v-model.trim="vm.ActivityThing" id="ActivityThing" :label="$t('views.g4s.communityactivityapplication.activityThing')"></form-textarea>
                        </div>
                        <div class="col-12">
                            <form-textarea v-model.trim="vm.Activity2Desc" id="Activity2Desc" :label="$t('views.g4s.communityactivityapplication.activity2Desc')"></form-textarea>
                        </div>
                        <div class="col-12">
                            <form-textarea v-model.trim="vm.Activity2People" id="Activity2People" :label="$t('views.g4s.communityactivityapplication.activity2People')"></form-textarea>
                        </div>
                        <div class="col-12">
                            <form-textarea v-model.trim="vm.Activity2Thing" id="Activity2Thing" :label="$t('views.g4s.communityactivityapplication.activity2Thing')"></form-textarea>
                        </div>
                    </div>
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-4 @click="show">{{$t('views.g4s.communityactivityapplication.expectedBudget_card')}}</b-button>
            <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel" v-if="isedit">
                <table class="table">
                    <thead>
                        <tr>
                            <th>{{$t('views.g4s.communityactivityapplication.expectedBudgetSeq')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.expectedBudgetName')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.expectedBudgetPurpose')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.expectedBudgetUnit')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.expectedBudgetPrice')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.expectedBudgetQuantity')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.expectedBudgetTotal')}}</th>
                            <th>{{$t('views.g4s.communityactivityapplication.expectedBudgetRemark')}}</th>
                            <th v-if="!isSendOrPass"></th>
                        </tr>
                    </thead>
                    <tr v-for="(item, index) in budgetTableData.value" :key="item.CommunityActivityApplicationBudgetID">
                        <td>{{index + 1}}</td>
                        <td>{{item.Name}}</td>
                        <th>{{item.Purpose}}</th>
                        <th>{{item.Unit}}</th>
                        <th>{{item.Price}}</th>
                        <th>{{item.Quantity}}</th>
                        <th>{{item.Total}}</th>
                        <th>{{item.Remark}}</th>
                        <th v-if="!isSendOrPass">
                            <b-button variant="danger" @click="budgetDel(item.CommunityActivityApplicationBudgetID)">{{$t('views.g4s.communityactivityapplication.delete')}}</b-button>
                        </th>
                    </tr>
                    <tr v-if="!isSendOrPass">
                        <td data-th="項次"></td>
                        <td data-th="支出項目">
                            <input v-model="budget.Name" type="text" class="form-control" />
                        </td>
                        <td data-th="用途說明">
                            <input v-model="budget.Purpose" type="text" class="form-control" />
                        </td>
                        <td data-th="單位">
                            <input v-model="budget.Unit" type="text" class="form-control" />
                        </td>
                        <td data-th="單價">
                            <input v-model="budget.Price" type="number" class="form-control" @change="budgetChange" />
                        </td>
                        <td data-th="數量">
                            <input v-model="budget.Quantity" type="number" class="form-control" @change="budgetChange" />
                        </td>
                        <td data-th="總額">
                            <input v-model="budget.Total" type="number" class="form-control" disabled />
                        </td>
                        <td data-th="備註">
                            <input v-model="budget.Remark" type="text" class="form-control" />
                        </td>
                        <td>
                            <div class="form-group">
                                <b-button variant="primary" @click="budgetSave">{{$t('views.g4s.communityactivityapplication.insert')}}</b-button>
                            </div>
                        </td>
                    </tr>
                </table>
                <div class="col-12 text-right font-weight-bold">
                    <p><u>{{$t('views.g4s.communityactivityapplication.expectedBudgetTotals')}}：{{budgetTotal}}</u></p>
                </div>
                <pagination v-model="pager" :rows="budgetTableData.count" :rowperpage="10" @paging="load"></pagination>
            </b-collapse>
        </div>
        <template slot="modal-footer">
            <b-button variant="info" @click="send" v-if="isSave && !isSendOrPass">{{$t('components.modal.sendToReview')}}</b-button>
            <b-button variant="primary" @click="save" v-if="!isSendOrPass"><b-icon-file-check></b-icon-file-check>{{$t('components.modal.ok')}}</b-button>
            <b-button variant="secondary" @click="cancel"><b-icon-x></b-icon-x>{{$t('components.modal.cancel')}}</b-button>
        </template>
    </b-modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'communityactivityapplicationDetail',
        api: '/api/communityactivityapplication/',
        data: {
            classList: [],
            propertys: [],
            property: '',
            Communitys: [],
            budget: { CommunityActivityApplicationBudgetID: '', Name: '', Purpose: '', Unit: '', Price: 0, Quantity: 0, Total: 0, Remark: '', CommunityActivityApplicationID: '' },
            budgetTableData: { count: 0, value: [] },
            budgetTotal: 0,
            unionCommunitys: [],
            union: { CommunityActivityUnionID: '', property: '', CommunityID: '' },
            unionTableData: { count: 0, value: [] },
            pager: {},
            vm: { Files: [] },
        },
        created: function () {
            this.$parameter.communityproperty().then((res) => { this.propertys = res.data; });
            this.$parameter.community().then((res) => { this.Communitys = res.data; this.unionCommunitys = res.data; });
            this.$parameter.class('', '', '', '', '').then((res) => { this.classList = res.data.Class; });
        },
        computed: {
            Path: function () { return this.$apiurl + this.vm.Dir },
            isSendOrPass: function () {return this.vm.Approved == 'W' || this.vm.Approved == 'Y' }
        },
        methods: {
            load: function () {
                return this.$http({ method: 'get', url: 'api/communityactivityapplicationbudget/Get?id=' + this.vm.CommunityActivityApplicationID, headers: this.pager })
                    .then(res => {
                        if (res.data) {
                            this.budgetTableData.count = res.data.count;
                            this.budgetTableData.value = res.data.value;
                            this.budgetTotal = this.budgetTableData.value.reduce((acc, item) => acc + item.Total, 0);
                        } else {
                            this.budgetTableData.count = 0;
                            this.budgetTableData.value = [];
                        }
                    });
            },
            reload: function () {
                this.pager.skip = 0;
                return this.load();
            },
            studentNoChange: function ()
            {
                this.$parameter.sclass(this.vm.StudentNo)
                    .then((res) => {
                        this.vm.StudentName = res.data.name;
                        this.$parameter.class('', '', '', '', res.data.classValue).then(x => this.classList = x.data.Class);
                    })
            },
            selfCheckChange: function (e) {
                if (e == "4") {
                    this.vm.SelfCheck4 = true;
                    this.vm.SelfCheck5 = false;
                }
                if (e == "5") {
                    this.vm.SelfCheck4 = false;
                    this.vm.SelfCheck5 = true;
                }
                    
            },
            isSave: function () {
                if (!this.isedit) {
                    // todo: 待修繕
                    let message = '請先儲存基本資料';
                    if (this.$i18n.locale === 'en') {
                        message = 'Please save essential information';
                    }
                    this.$bvToast.toast(message, { title: '發生錯誤', variant: 'warning', solid: true });
                    return false;
                } else {
                    return true;
                }
            },
            send: function () {
                if (this.isSave()) {
                    if (this.vm.BigScale && (this.vm.Files == null || this.vm.Files.length == 0)) {
                        // todo: 待修繕
                        let message = '尚未上傳附件';
                        if (this.$i18n.locale === 'en') {
                            message = 'Details of the activity process attachment not uploaded yet';
                        }
                        return this.$bvToast.toast(message, { title: '', variant: 'danger', solid: true });
                    }
                    return this.$http({ method: 'patch', url: 'api/communityactivityapplication/Send?id=' + this.vm.CommunityActivityApplicationID })
                        .then(() => {
                            // todo: 待修繕
                            let message = '送出審查成功';
                            if (this.$i18n.locale === 'en') {
                                message = 'send success';
                            }
                            this.$bvToast.toast(message, { title: '', variant: 'success', solid: true });
                            this.$emit('reload');
                            this.$bvModal.hide(this.id);
                        });
                }
            },
            show: function () {
                if (this.isSave()) {
                    this.reload();
                }
            },
            ok: function (e) {
                // todo: 待修繕
                let message = '上傳成功';
                if (this.$i18n.locale === 'en') {
                    message = 'upload success';
                }
                this.$bvToast.toast(message, { title: '', variant: 'success', solid: true });
                if (this.vm.Files == null) {
                    this.vm.Files = [];
                }
                if (!this.vm.Files.includes(e.res.data))
                    this.vm.Files.push(e.res.data);
            },
            budgetSave: function () {
                this.budget.CommunityActivityApplicationID = this.vm.CommunityActivityApplicationID;
                this.$http({ method: 'put', url: 'api/communityactivityapplicationbudget/Put', data: this.budget })
                    .then(() => {
                        this.budget.Name = '';
                        this.budget.Purpose = '';
                        this.budget.Unit = '';
                        this.budget.Price = 0;
                        this.budget.Quantity = 0;
                        this.budget.Total = 0;
                        this.budget.Remark = '';
                        this.reload();
                    });
            },
            budgetDel: function (id) {
                this.$http({ method: 'delete', url: 'api/communityactivityapplicationbudget/Delete/' + id })
                    .then(() => { this.reload(); })
            },
            budgetChange: function () {
                this.budget.Total = this.budget.Price * this.budget.Quantity;
            },
            unionSave: function () {
                this.union.CommunityActivityApplicationID = this.vm.CommunityActivityApplicationID;
                this.$http({ method: 'put', url: 'api/communityactivityunion/Put', data: this.union })
                    .then(() => {
                        this.union.Property = '';
                        this.union.CommunityID = '';
                        this.unionReload();
                    });
            },
            unionDel: function (id) {
                this.$http({ method: 'delete', url: 'api/communityactivityunion/Delete/' + id })
                    .then(() => { this.unionReload(); })
            },
            show2: function () {
                if (this.isSave()) {
                    this.unionReload();
                }
            },
            unionLoad: function () {
                return this.$http({ method: 'get', url: 'api/communityactivityunion/Get?id=' + this.vm.CommunityActivityApplicationID, headers: this.pager })
                    .then(res => {
                        if (res.data) {
                            this.unionTableData.count = res.data.count;
                            this.unionTableData.value = res.data.value;
                        } else {
                            this.unionTableData.count = 0;
                            this.unionTableData.value = [];
                        }
                    });
            },
            unionReload: function () {
                this.pager.skip = 0;
                return this.unionLoad();
            },
        },
        watch: {
            property: function (value) {
                if (value) {
                    this.$parameter.community(value).then((res) => { this.Communitys = res.data; });
                }
            },
            "union.property": function (value) {
                if (value) {
                    this.$parameter.community(value).then((res) => { this.unionCommunitys = res.data; });
                }
            },
        }
    });
</script>

<style>
</style>